<mat-card appearance="outlined" class="mt-3">
  <div class="row m-3">
    <div tabindex="0" class="col-12 col-md-6">
      <mat-card-title>{{ subscription.productDescription }}</mat-card-title>
      <mat-card-subtitle *ngIf="subscription.subId"
                         [innerHTML]="translationService.getTranslation('order_id') + ': ' + subscription.subId">
      </mat-card-subtitle>
      <mat-card-subtitle *ngIf="subscription.userBackendId"
                         [innerHTML]="translationService.getTranslation('label_backendid') + ': ' + subscription.userBackendId">
      </mat-card-subtitle>
      <mat-card-subtitle *ngIf="subscription.variantDescription"
                         [innerHTML]="translationService.getTranslation('order_edition') + ': ' + subscription.variantDescription">
      </mat-card-subtitle>
      <mat-card-subtitle *ngIf="subscription.validDate" [innerHTML]="translationService.getTranslation('period') + ': ' +
                               (subscription.validDate.validFrom | date) + ' - ' +
                               ((subscription.validDate.validUntil) ? (subscription.validDate.validUntil | date) : translationService.getTranslation('subscription_endless'))">
      </mat-card-subtitle>
      <mat-card-subtitle *ngIf="subscription.curDelivery">
        {{ subscription.curDelivery.person.addressCodeDescription }}
        {{ subscription.curDelivery.person.firstname }}
        {{ subscription.curDelivery.person.lastname }},
        {{ subscription.curDelivery.address.city }},
        {{ subscription.curDelivery.address.street }} {{ subscription.curDelivery.address.houseno | houseNoPipe }}
      </mat-card-subtitle>
    </div>
    <div class="col-12 col-md-6">
      <mat-card-actions class="card-actions">
        <button mat-raised-button color="primary" [innerHTML]="actionLabel"
                (click)="action.emit(subscription)"></button>
      </mat-card-actions>
    </div>
  </div>
</mat-card>
